module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAECAYAAABhnXSoAAAARUlEQVQYla3MsRFAQBAAwGVICcx8M1oR6kEVcuG3oKZvgUhiPlCB2wK2ec4pYcXgvxu5w44lIPzMLWocqa/hhoIxYL5wvCRTCArnCtnNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/images/yellowline.png
// module id = sUZR
// module chunks = 1